import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TransitionLoader from './common/TransitionLoader';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // 1. If Auth is still loading, show a spinner (DON'T redirect yet)
  if (loading) {
    return <TransitionLoader />;
  }

  // 2. If no user is logged in, send to Login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 3. DEBUGGING: Print the role to Console so we can see what's happening
  console.log("AdminRoute Check -> User:", user.email, "Role:", user.role);

  // 4. If user exists but is NOT an admin, kick them out
  if (user.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  // 5. If they represent the law, let them in 👮‍♂️
  return children;
};

export default AdminRoute;